<template>
  <div ref="consumption" class="consumption-item-box-cla">
    <label class="type-name-cla">{{ typeName }}:</label>
    <svg
      :style="{ width: length + 'px', height: '20px', margin: '0px 20px' }"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
    >
      <defs>
        <g id="usage-bar-id">
          <line stroke-width="10" x1="0" y1="10" :x2="length" y2="10" />
        </g>
      </defs>
      <use class="usage-bar-cla" xlink:href="#usage-bar-id" />
      <use
        :style="{
          stroke: '#7AC143',
          'stroke-dasharray': [length, length],
          strokeDashoffset: strokeDashoffset + 'px'
        }"
        xlink:href="#usage-bar-id"
      />
    </svg>
    <div>
      <span class="current-cla">{{ current }}</span>
      <span>/</span>
      <span>{{ maxCount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      length: 300
    }
  },
  mounted() {
    this.length = this.$refs.consumption.clientWidth - 400
  },
  computed: {
    strokeDashoffset() {
      return this.length - this.length * (this.current / this.maxCount)
    }
  },
  props: {
    typeName: {
      type: String,
      default: ''
    },
    maxCount: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style scoped lang="less">
.usage-bar-cla {
  fill: none;
  stroke: #d7d7d7;
}
.consumption-item-box-cla {
  display: flex;
  align-items: center;
  margin: 5px 0px;
  .current-cla {
    color: #7ac143;
  }

  .type-name-cla{
     min-width: 150px;
     text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceCmp/consumption.vue